module.exports = __webpack_public_path__ + "img/message.44d8d23a.svg";